module.exports = __webpack_public_path__ + "img/8_wind.ea03dc03.jpg";